import React, { Component } from "react";
import { render } from "react-dom";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import { compose, withProps, withStateHandlers } from "recompose";
import { connect } from "react-redux";

import {
  MARKER_MOVE,
  MARKER_DRAGGING,
  MARKER_SELECTING,
  DEL_MARKER
} from "../../../reducers/map";

class DropMarker extends Component {
  selectInfo = arg => {
    this.props.MARKER_SELECTING(this.props.id);


  };

  onDragStart = arg => {
    this.closeInfo()
    this.props.MARKER_DRAGGING(this.props.id);


  };

  onDragEnd = e => {
    this.props.position.lat = e.latLng.lat();
    this.props.position.lng = e.latLng.lng();
    // let newPosition = {
    //   position: {
    //     lat: e.latLng.lat(),
    //     lng: e.latLng.lng()
    //   }
    // };
    this.props.MARKER_MOVE(this.props);
  };

  closeInfo = () => {
    this.props.MARKER_SELECTING(-1)
  }

  render() {
    const id = this.props.id;
    let selected = false;
    if (this.props.marker_selecting === id) {
      selected = true;
    }

    let icon_url;
    let label = "";
    let size = new window.google.maps.Size(40, 40);

    // http://maps.google.com/mapfiles/kml/paddle/wht-blank.png

    //https://sites.google.com/site/gmapicons/home/
    if (this.props.isFirst) {
      icon_url = "http://www.google.com/mapfiles/dd-start.png";
      size = new window.google.maps.Size(22, 36);
    } else if (this.props.isLast) {
      icon_url = "http://www.google.com/mapfiles/dd-end.png";
      size = new window.google.maps.Size(22, 36);
    } else if (this.props.marker_MovingAdding === id) {
      icon_url = "http://maps.google.com/mapfiles/ms/icons/red.png";
      label = (id+1).toString();
    } else {
      icon_url = "http://maps.google.com/mapfiles/ms/icons/blue.png";
      label = (id+1).toString();
    }

    if(this.props.isCompleted === true){
        icon_url = "http://maps.google.com/mapfiles/ms/icons/blue.png"
    } else {
        icon_url = "http://maps.google.com/mapfiles/kml/paddle/wht-blank.png"
    }

    const _this = this;

    let actualArrivalTime = ""
    let planArrivalTime = ""
    let actualDepartureTime = ""
    let planDepartureTime = ""

    if(this.props.suggestion_selecting > -1) {
       actualArrivalTime = this.props.route_data.routes[this.props.suggestion_selecting].Legs[this.props.id].actualArrivalTime
       planArrivalTime = this.props.route_data.routes[this.props.suggestion_selecting].Legs[this.props.id].planArrivalTime
       actualDepartureTime = this.props.route_data.routes[this.props.suggestion_selecting].Legs[this.props.id].actualDepartureTime
       planDepartureTime = this.props.route_data.routes[this.props.suggestion_selecting].Legs[this.props.id].planDepartureTime

      actualArrivalTime = actualArrivalTime ? actualArrivalTime.split(" ")[1] : ""
      planArrivalTime = planArrivalTime ? planArrivalTime.split(" ")[1] : ""
      actualDepartureTime = actualDepartureTime ? actualDepartureTime.split(" ")[1] : ""
      planDepartureTime = planDepartureTime ? planDepartureTime.split(" ")[1] : ""
    } else {

    }

    return (

      // this.props.route_data[suggestion_selecting].Legs[this.props.id].actualArrivalTime
      

      <div>
        <Marker
          position={this.props.position}
          label={label}
          icon={{
            url: icon_url,
            labelOrigin: new window.google.maps.Point(19, 14),
            scaledSize: size,
            size: size
          }}
          key={this.props.key}
          // defaultDraggable={this.props.defaultDraggable}
          onClick={this.selectInfo}
          onDragStart={this.onDragStart}
          // onMouseOver={this.onDragStart}
          // onMouseOut={this.props.mapClearInfo}
          // mapClearInfo={this.props.mapClearInfo}
          onDragEnd={this.onDragEnd}>
          {selected ? (
            <div>
              <InfoWindow onCloseClick={this.closeInfo}>
                <div>
                  <div>
                    <div><b>{this.props.locationName}</b></div>
                    <div>Actual Arrival Time : {actualArrivalTime}</div>
                    <div>Plan Arrival Time : {planArrivalTime}</div>
                    <div>Actual Departure Time : {actualDepartureTime}</div>
                    <div>Plan Departure Time : {planDepartureTime}</div>
                    {/* <div>ETA : {this.props.infoETA}</div> */}
                  </div>
                  <div>
                    {/* {!(this.props.isFirst || this.props.isLast) && (
                      <button onClick={() => this.props.DEL_MARKER(id)}>
                        Delete
                      </button>
                    )} */}
                  </div>
                </div>
              </InfoWindow>
            </div>
          ) : null}
        </Marker>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    marker_selecting: state.map.marker_selecting,
    marker_MovingAdding: state.map.marker_MovingAdding,
    marker_Dragging: state.map.marker_MovingAdding,
    suggestion_selecting: state.map.suggestion_selecting,
  };
};

const mapActionsToProps = {
  // CIRCLE_SELECTING : mapSelectedCircle ,
  // CIRCLE_CHANGE : mapChangeCircle ,
  MARKER_MOVE : MARKER_MOVE,
  MARKER_DRAGGING : MARKER_DRAGGING,
  MARKER_SELECTING: MARKER_SELECTING,
  DEL_MARKER : DEL_MARKER
};

// const mapDispatchToProps = dispatch => {
//   return {
//     DEL_MARKER: value => dispatch({ type: "DEL_MARKER", value: value }),
//     MARKER_SELECTING: id => dispatch({ type: "MARKER_SELECTING", value: id }),
//     MARKER_DRAGGING: id => dispatch({ type: "MARKER_DRAGGING", value: id }),
//     MARKER_MOVE: id => dispatch({ type: "MARKER_MOVE", value: id })
//   };
// };

export default connect(
  mapStateToProps,
  mapActionsToProps
)(DropMarker);
